import { useSearchParams } from "react-router-dom";
import CmsHomeEditor from "./CmsHomeEditor";

const TABS = [
  { id: "inteligencia", label: "Centro Inteligencia" },
  { id: "servicios", label: "Tarjeta Servicio" },
];

export default function CmsHomePage() {
  const [params, setParams] = useSearchParams();
  const raw = params.get("tab") || "inteligencia";
  const tab = TABS.some((t) => t.id === raw) ? raw : "inteligencia";

  return (
    <div className="space-y-6 max-w-5xl">
      <div>
        <h2 className="font-display text-3xl font-black">Home</h2>
        <p className="text-sm text-brand-dark/55 mt-1">
          Contenido de la portada: centro de inteligencia y tarjetas de servicio.
        </p>
      </div>

      <nav className="flex flex-wrap gap-1 border-b border-brand-soft">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setParams({ tab: t.id })}
            className={`px-4 py-2.5 text-sm ${
              tab === t.id
                ? "border-b-2 border-brand-primary font-bold text-brand-primary"
                : "text-brand-dark/55 hover:text-brand-dark"
            }`}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {tab === "inteligencia" ? <CmsHomeEditor variant="inteligencia" embedded /> : null}
      {tab === "servicios" ? <CmsHomeEditor variant="servicios" embedded /> : null}
    </div>
  );
}
